<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog></p-confirmDialog>

@if (showCreatePromotion) {
  <div class="create-view">
    <div class="create-header">
      <h2>VRBO Promotions - {{ editingPromotion ? 'Edit' : 'Create' }}</h2>
      <button pButton label="Back to Dashboard" icon="pi pi-arrow-left" class="p-button-outlined p-button-sm" (click)="backToDashboard()"></button>
    </div>
    <app-vrbo-promotions [editPromotion]="editingPromotion"></app-vrbo-promotions>
  </div>
}

@if (!showCreatePromotion) {
<div class="promotions-dashboard">
  <!-- Panel 1: Left Sidebar -->
  <div class="panel panel-left">
    <div class="panel-controls">
      <span class="w-full mb-2">
        <input pInputText type="text" [(ngModel)]="propertySearch" placeholder="Search properties..." class="w-full" />
      </span>

      <div class="toggle-row mb-2">
        <p-inputSwitch [(ngModel)]="withPromotionsOnly"></p-inputSwitch>
        <span>With promotions only</span>
      </div>

      <p-dropdown
        [options]="promotionTypeOptions"
        [(ngModel)]="missingPromotionType"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        appendTo="body"
        placeholder="Missing: Select type"
        styleClass="w-full">
      </p-dropdown>
    </div>

    @if (resolvedMissingType) {
      <div class="missing-info-bar">
        <i class="pi pi-exclamation-circle"></i>
        <span><span class="missing-count">{{filteredProperties.length}}</span> properties missing <strong>{{getPromotionTypeLabel(resolvedMissingType)}}</strong></span>
      </div>
    }

    @if (!loadingProperties) {
      <div class="property-list">
        @for (p of filteredProperties; track p) {
          <div
            class="property-row"
            [class.selected]="p.propertyId === selectedPropertyId"
            [class.missing-highlight]="resolvedMissingType && !p.activeTypes.includes(resolvedMissingType)"
            (click)="selectProperty(p)">
            <div class="property-row-top">
              <span class="property-name">{{p.name}}</span>
              <span class="property-count">{{p.promotionCount}}</span>
            </div>
            <div class="property-id">ID: {{p.propertyId}}</div>
            <div class="dots">
              @for (t of promotionTypeOptions; track t) {
                <span
                  class="dot"
                  [ngStyle]="{
                    'background-color': p.activeTypes.includes(t.value) ? getPromotionColor(t.value) : '#fff',
                    'border-color': getPromotionColor(t.value)
                  }"
                  [class.dot-missing]="resolvedMissingType === t.value && !p.activeTypes.includes(t.value)">
                </span>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="p-3 text-center">
        <p-progressSpinner [style]="{width:'28px',height:'28px'}"></p-progressSpinner>
      </div>
    }
  </div>

  <!-- Panel 2: Center -->
  <div class="panel panel-center">
    <div class="toolbar-row">
      <p-selectButton
        [options]="[{label:'Single',value:'SINGLE'},{label:'Multi',value:'MULTI'},{label:'List',value:'LIST'}]"
        [(ngModel)]="viewMode">
      </p-selectButton>
      <h2>{{monthLabel}}</h2>
      <div class="nav-actions">
        <button pButton icon="pi pi-chevron-left" class="p-button-text p-button-sm" (click)="previousMonth()"></button>
        <button pButton icon="pi pi-chevron-right" class="p-button-text p-button-sm" (click)="nextMonth()"></button>
        <button pButton label="Today" class="p-button-outlined p-button-sm" (click)="goToday()"></button>
      </div>
    </div>
    <div class="toolbar-row second">
      <p-multiSelect
        [options]="promotionTypeOptions"
        [(ngModel)]="selectedPromotionTypes"
        optionLabel="label"
        optionValue="value"
        defaultLabel="All promotion types"
        [showToggleAll]="false"
        styleClass="mr-2">
      </p-multiSelect>
      <p-selectButton
        [options]="[{label:'Active',value:'ACTIVE'},{label:'Future',value:'FUTURE'},{label:'Expired',value:'EXPIRED'},{label:'Inactive',value:'INACTIVE'},{label:'All',value:'ALL'}]"
        [(ngModel)]="statusFilter">
      </p-selectButton>
      <p-selectButton
        [options]="[{label:'All Sources',value:'ALL'},{label:'VRBO',value:'VRBO'},{label:'Wiki',value:'WIKI'}]"
        [(ngModel)]="sourceFilter"
        styleClass="ml-2">
      </p-selectButton>
      @if (viewMode === 'LIST') {
        <div class="ml-auto list-only">
          <span class="mr-2">Group by Property</span>
          <p-inputSwitch [(ngModel)]="groupByProperty" class="mr-3"></p-inputSwitch>
          <button pButton label="Export" icon="pi pi-download" class="p-button-outlined p-button-sm mr-2"></button>
          <button pButton label="Create" icon="pi pi-plus" class="p-button-sm" (click)="createPromotion()"></button>
        </div>
      }
    </div>
    <div class="legend-row">
      @for (t of promotionTypeOptions; track t) {
        <span class="legend-item">
          <span class="dot" [style.background]="getPromotionColor(t.value)"></span>{{t.label}}
        </span>
      }
      <span class="legend-item"><span class="blackout-x">X</span>Blackout</span>
    </div>

    @if (resolvedMissingType) {
      <div class="center-missing-banner">
        <span class="missing-count-large">{{filteredProperties.length}}</span>
        <span class="missing-label">properties missing <strong>{{getPromotionTypeLabel(resolvedMissingType)}}</strong> promotion</span>
      </div>
    }

    <!-- LIST VIEW: Missing Properties Table -->
    @if (viewMode === 'LIST' && resolvedMissingType) {
      <div class="center-content">
        <p-table [value]="missingPropertiesSorted" [paginator]="true" [rows]="15" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th>Property</th>
              <th style="width:60px;">Active</th>
              <th>Coverage</th>
              <th>Active Types</th>
              <th style="width:100px;">Types</th>
              <th style="width:80px;">Action</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-p>
            <tr [class.selected-row]="p.propertyId === selectedPropertyId" (click)="selectProperty(p)">
              <td>
                <div class="font-medium">{{p.name}}</div>
                <small class="text-muted">{{p.propertyCode}} &middot; ID: {{p.propertyId}}</small>
              </td>
              <td class="text-center">
                <span class="property-count">{{p.promotionCount}}</span>
              </td>
              <td>
                <span class="pill" [class.coverage-none]="p.activeTypes.length === 0" [class.coverage-partial]="p.activeTypes.length > 0 && p.activeTypes.length < promotionTypeOptions.length" [class.coverage-full]="p.activeTypes.length === promotionTypeOptions.length">
                  {{getCoverage(p)}}
                </span>
              </td>
              <td>
                @if (!p.activeTypes.length) {
                  <span class="text-muted">None</span>
                }
                @if (p.activeTypes.length) {
                  <span>{{getActiveTypeLabels(p)}}</span>
                }
              </td>
              <td>
                <div class="dots" style="margin-top:0">
                  @for (t of promotionTypeOptions; track t) {
                    <span
                      class="dot"
                      [ngStyle]="{
                        'background-color': p.activeTypes.includes(t.value) ? getPromotionColor(t.value) : '#fff',
                        'border-color': getPromotionColor(t.value)
                      }"
                      [class.dot-missing]="resolvedMissingType === t.value && !p.activeTypes.includes(t.value)">
                    </span>
                  }
                </div>
              </td>
              <td>
                <button pButton icon="pi pi-plus" class="p-button-text p-button-sm p-button-success" pTooltip="Create {{getPromotionTypeLabel(resolvedMissingType)}}" tooltipPosition="left" (click)="createPromotion(); $event.stopPropagation()"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="6" class="text-center p-4 text-muted">No properties missing this promotion type.</td></tr>
          </ng-template>
        </p-table>
      </div>
    }

    <!-- LIST VIEW: Promotions Table (default) -->
    @if (viewMode === 'LIST' && !resolvedMissingType) {
      <div class="center-content">
        <p-table [value]="allVisiblePromotions" [paginator]="true" [rows]="10" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th style="width:30px;"></th>
              <th>Property</th>
              <th>Type</th>
              <th>Coupon</th>
              <th>Status</th>
              <th>Discount</th>
              <th>Markup</th>
              <th>Travel Dates</th>
              <th>Booking Window</th>
              <th>Stay</th>
              <th>Blackouts</th>
              <th>Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-p>
            <tr (click)="openDetail(p)" [class.selected-row]="selectedPromotion?.id === p.id">
              <td><span class="dot" [style.background]="getPromotionColor(p.promotionType)"></span></td>
              <td>
                <div class="font-medium">{{p.propertyName}}</div>
                <small class="text-muted">ID: {{p.propertyId}}</small>
              </td>
              <td>
                <span class="pill type-pill">{{getPromotionTypeLabel(p.promotionType)}}</span>
                @if (isWikiCoupon(p)) {
                  <span class="pill scope-pill"
                    [class.scope-global]="isGlobalWikiCoupon(p)"
                    [class.scope-specific]="!isGlobalWikiCoupon(p)"
                    [pTooltip]="isGlobalWikiCoupon(p) ? 'Applies to all properties' : 'Applies only to specific properties'"
                    tooltipPosition="top">
                    {{getWikiScopeLabel(p)}}
                  </span>
                }
              </td>
              <td>
                @if (p.couponCode) {
                  <span class="coupon-code">{{p.couponCode}}</span>
                  @if (p.isAutoApplied) {
                    <span class="auto-badge" pTooltip="Auto-applied coupon" tooltipPosition="top">AUTO</span>
                  }
                } @else {
                  <span class="text-muted">--</span>
                }
              </td>
              <td><span class="pill" [class.active-pill]="p.status === 'ACTIVE'" [class.inactive-pill]="p.status === 'INACTIVE'" [class.future-pill]="p.status === 'FUTURE'" [class.expired-pill]="p.status === 'EXPIRED'">{{p.status}}</span></td>
              <td>{{getDiscountText(p)}}</td>
              <td [pTooltip]="getMarkupTooltip(p)" tooltipPosition="top">{{getMarkupText(p)}}</td>
              <td>{{getTravelText(p)}}</td>
              <td>{{getBookingWindowText(p)}}</td>
              <td>{{getStayText(p)}}</td>
              <td><span class="blackout-badge">{{getBlackoutCount(p)}}</span></td>
              <td class="actions">
                <button pButton icon="pi pi-pencil" class="p-button-text p-button-sm" pTooltip="Edit" tooltipPosition="top" (click)="editPromotion(p); $event.stopPropagation()"></button>
                <button pButton [icon]="isActive(p.status) ? 'pi pi-ban' : 'pi pi-check'" class="p-button-text p-button-sm" [pTooltip]="isActive(p.status) ? 'Deactivate' : 'Activate'" tooltipPosition="top" (click)="togglePromotionStatus(p); $event.stopPropagation()"></button>
                @if (isActive(p.status)) {
                  <button pButton icon="pi pi-times-circle" class="p-button-text p-button-sm p-button-danger" pTooltip="Deactivate for all properties" tooltipPosition="top" [disabled]="bulkDeactivating" (click)="deactivateForAllProperties(p); $event.stopPropagation()"></button>
                }
                <button pButton icon="pi pi-copy" class="p-button-text p-button-sm" pTooltip="Duplicate" tooltipPosition="top" (click)="duplicatePromotion(p); $event.stopPropagation()"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }

    <!-- SINGLE MONTH VIEW -->
    @if (viewMode === 'SINGLE') {
      <div class="center-content month-grid-wrap">
        <div class="month-grid-header">
          @for (d of ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']; track d) {
            <div>{{d}}</div>
          }
        </div>
        <div class="month-grid">
          @for (day of getMonthDays(); track day) {
            <div
              class="day-cell"
              [class.outside]="day.month() !== currentMonth.month()"
              [class.today]="isToday(day)">
              <div class="day-number">{{day.date()}}</div>
              <div class="dots">
                @for (promo of getPromotionsForDay(day) | slice:0:5; track promo) {
                  <span
                    class="dot"
                    [style.background]="getPromotionColor(promo.promotionType)"
                    (click)="openDetail(promo)">
                  </span>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- MULTI VIEW -->
    @if (viewMode === 'MULTI') {
      <div class="center-content multi-view">
        <div class="text-muted mb-2">Multi-property timeline (next 14 days)</div>
        <div class="multi-grid">
          @for (p of filteredProperties | slice:0:20; track p) {
            <div class="multi-row">
              <div class="multi-prop">{{p.name}}</div>
              <div class="multi-days">
                @for (n of multiDayColumns; track n) {
                  <div class="multi-day">
                    @for (promo of applyPromotionFilters(promotionsByProperty[p.propertyId] || []) | slice:0:3; track promo) {
                      <span
                        class="dot"
                        [style.background]="getPromotionColor(promo.promotionType)">
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!-- Panel 3: Detail -->
  @if (detailVisible && selectedPromotion) {
    <div class="panel panel-right">
      <div class="detail-header">
        <div>
          <h3>{{getPromotionTypeLabel(selectedPromotion.promotionType)}} PROMOTION</h3>
          <span class="pill" [class.active-pill]="selectedPromotion.status === 'ACTIVE'" [class.inactive-pill]="selectedPromotion.status === 'INACTIVE'" [class.future-pill]="selectedPromotion.status === 'FUTURE'" [class.expired-pill]="selectedPromotion.status === 'EXPIRED'">
            {{selectedPromotion.status}}
          </span>
          @if (isWikiCoupon(selectedPromotion)) {
            <span class="pill scope-pill ml-2"
              [class.scope-global]="isGlobalWikiCoupon(selectedPromotion)"
              [class.scope-specific]="!isGlobalWikiCoupon(selectedPromotion)"
              [pTooltip]="isGlobalWikiCoupon(selectedPromotion) ? 'Applies to all properties' : 'Applies only to specific properties'"
              tooltipPosition="top">
              {{getWikiScopeLabel(selectedPromotion)}}
            </span>
          }
        </div>
        <button pButton icon="pi pi-times" class="p-button-text" (click)="closeDetail()"></button>
      </div>
      <div class="detail-section">
        <div class="section-title">PROPERTY</div>
        <div>{{selectedPromotion.propertyName}}</div>
        <small class="text-muted">ID: {{selectedPromotion.propertyId}}</small>
      </div>
      <div class="detail-section">
        <div class="section-title">DISCOUNT</div>
        <div>{{getDiscountText(selectedPromotion)}}</div>
      </div>
      <div class="detail-section">
        <div class="section-title">TRAVEL DATES</div>
        <div>{{getTravelText(selectedPromotion)}}</div>
      </div>
      <div class="detail-section">
        <div class="section-title">BOOKING WINDOW</div>
        <div>{{getBookingWindowText(selectedPromotion)}}</div>
      </div>
      <div class="detail-section">
        <div class="section-title">STAY DURATION</div>
        <div>{{getStayText(selectedPromotion)}}</div>
      </div>
      <div class="detail-section">
        <div class="section-title">BLACKOUT DATES</div>
        @if (getBlackoutCount(selectedPromotion) === 0) {
          <div class="text-muted">None</div>
        }
        @for (b of selectedPromotion.restrictions?.blackoutDates || []; track b) {
          <div>{{formatDateUS(b.travelDateFrom)}} - {{formatDateUS(b.travelDateTo)}}</div>
        }
      </div>
      <div class="detail-actions">
        <button pButton label="Edit" class="p-button-sm" (click)="editPromotion(selectedPromotion)"></button>
        <button pButton [label]="isActive(selectedPromotion.status) ? 'Deactivate' : 'Activate'" class="p-button-outlined p-button-sm" (click)="togglePromotionStatus(selectedPromotion)"></button>
        @if (isActive(selectedPromotion.status)) {
          <button pButton label="Deactivate All Properties" icon="pi pi-ban"
            class="p-button-danger p-button-outlined p-button-sm"
            [disabled]="bulkDeactivating"
            pTooltip="Deactivate this promotion type across all properties" tooltipPosition="top"
            (click)="deactivateForAllProperties(selectedPromotion)"></button>
        }
        <button pButton label="Duplicate" class="p-button-secondary p-button-sm" (click)="duplicatePromotion(selectedPromotion)"></button>
      </div>
      @if (bulkDeactivating) {
        <div class="bulk-progress mt-2">
          <small class="text-muted">Deactivating {{bulkDeactivateProgress}} of {{bulkDeactivateTotal}}...</small>
          <p-progressBar [value]="(bulkDeactivateProgress / bulkDeactivateTotal) * 100" [showValue]="false" [style]="{'height':'6px'}"></p-progressBar>
        </div>
      }
    </div>
  }
</div>
}
